import { jsx } from 'react/jsx-runtime';
import PropTypes from 'prop-types';

const THead = ({
  children,
  className,
  testSection,
  ...props
}) => {
  return /* @__PURE__ */ jsx("thead", { className, "data-test-section": testSection, ...props, children });
};
THead.propTypes = {
  /** Should be a `Table.TR` component */
  children: PropTypes.node,
  /** CSS class names. */
  className: PropTypes.string,
  /** Hook for automated JavaScript tests */
  testSection: PropTypes.string
};
THead.displayName = "Table.THead";

export { THead as default };
